function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var textTypes = require('../textTypes');

var tooltipOnEllipsis = require('../tooltipOnEllipsis');

var TextLabelBase = require('../textLabelBase');

var TooltipOnEllipsis = require('../tooltipOnEllipsis');

var ellipsisPropsNames = ['closeOnMouseClick', 'contentClassName', 'customTrigger', 'customTooltipMessage', 'displayCustomTrigger', 'marginTop', 'marginLeft'];

var TextLabel = /*#__PURE__*/function (_React$Component) {
  _inherits(TextLabel, _React$Component);

  var _super = _createSuper(TextLabel);

  function TextLabel(props) {
    var _this;

    _classCallCheck(this, TextLabel);

    _this = _super.call(this, props);

    _this.getTextLabelBaseProps = function () {
      return _(_this.props).pick(['value', 'type', 'disabled', 'shouldTranslate']).assign({
        key: "".concat(_this.props.value, "-").concat(_this.props.type)
      }).value();
    };

    _this.getTooltipOnEllipsisProps = function () {
      return _this.props.ellipsisProps ? _.pick(_this.props.ellipsisProps, _.concat(ellipsisPropsNames, 'disabled', 'shouldTranslate')) : {};
    };

    return _this;
  }

  _createClass(TextLabel, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName('control-label' + (this.props.disabled ? ' disabled' : '') + (this.props.enableEllipsis ? ' with-ellipsis' : '')),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, this.props.enableEllipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, _extends({
        key: "tooltipOnEllipsisOnTextLabel"
      }, this.getTooltipOnEllipsisProps()), /*#__PURE__*/React.createElement(TextLabelBase, this.getTextLabelBaseProps())) : /*#__PURE__*/React.createElement(TextLabelBase, _extends({
        key: "tooltipOnEllipsisOnTextLabel"
      }, this.getTextLabelBaseProps())));
    }
  }]);

  return TextLabel;
}(React.Component);

TextLabel.displayName = displayNames.TEXT_LABEL;
TextLabel.propTypes = {
  value: PropTypes.string.isRequired,
  type: PropTypes.oneOf(textTypes.TYPES),
  disabled: PropTypes.bool,
  enableEllipsis: PropTypes.bool,
  ellipsisProps: PropTypes.shape(_.pick(tooltipOnEllipsis, ellipsisPropsNames))
};
TextLabel.defaultProps = {
  disabled: false,
  enableEllipsis: true
};
module.exports = compose(TextLabel);